import React from "react";
import StockSupplierService from "services/stock-supplier";

import { connect } from "react-redux";
import { loadSupplier } from "reducers/stock";

class StockSupplier extends React.Component {
  stockSupplierService = new StockSupplierService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.stockSupplierService
      .getAll()
      .then(({ data }) => this.props.loadSupplier(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { loadSupplier })(StockSupplier);
